import { Metro } from '../../../common/components/SearchHeader/constants';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { SidebarLinkSection } from '../../ResultView/Sidebar/SidebarLinkSection/SidebarLinkSection';
import { LinkSection } from '../LinkSection/LinkSection';

interface Props {
  filters: FilterChoice;
  isSidebar?: boolean;
}

const capitalCitiesToShowLinks = Object.keys(Metro);

const perthSpecificLinks = [
  {
    title: 'Emergency Dentist Perth',
    url: 'https://healthengine.com.au/dental/dental-emergency-in-perth-heres-what-you-need-to-do',
  },
];

const sydneySpecificLinks = [
  {
    title: 'Root Canal Sydney',
    url:
      'https://healthengine.com.au/dental/sydney-root-canal-guide-procedure-costs-and-cheapest-suburbs-to-get-one',
  },
];

const melbourneSpecificLinks = [
  {
    title: 'Emergency Dentist Melbourne',
    url:
      'https://healthengine.com.au/dental/your-guide-to-urgently-and-easily-finding-an-emergency-dentist-in-melbourne',
  },
  {
    title: 'Root Canal Melbourne',
    url:
      'https://healthengine.com.au/dental/melbourne-root-canal-guide-treatment-costs-and-cheapest-suburbs-to-get-one',
  },
];

export const DentalCareInformation = ({ filters, isSidebar = false }: Props) => {
  const links = [
    {
      title: 'Emergency Dentist',
      url:
        'https://healthengine.com.au/dental/what-is-a-dental-emergency-and-book-emergency-dentist',
    },
  ]
    .concat(filters.location?.metro === Metro.Perth ? perthSpecificLinks : [])
    .concat(filters.location?.metro === Metro.Sydney ? sydneySpecificLinks : [])
    .concat(filters.location?.metro === Metro.Melbourne ? melbourneSpecificLinks : [])
    .concat([
      {
        title: 'Root Canal',
        url: 'https://healthengine.com.au/dental/the-ultimate-guide-to-root-canals',
      },
      {
        title: 'Tooth Extraction',
        url:
          'https://healthengine.com.au/dental/tooth-extraction-procedure-aftercare-costs-and-recovery',
      },
      {
        title: 'Cosmetic Dentist',
        url:
          'https://healthengine.com.au/dental/the-complete-guide-to-cosmetic-dentistry-finding-best-cosmetic-dentist',
      },
      {
        title: 'Family Dentist',
        url:
          'https://healthengine.com.au/dental/family-dentist-why-you-need-one-and-how-it-can-benefit-your-family',
      },
      {
        title: 'Children’s dentist',
        url:
          'https://healthengine.com.au/dental/paediatric-dentists-and-how-they-provide-quality-childrens-dental-treatment',
      },
      {
        title: 'Special needs dentist',
        url:
          'https://healthengine.com.au/dental/special-needs-dentist-how-dental-care-works-in-down-syndrome-cerebral-palsy',
      },
      {
        title: 'Dental Checkup',
        url:
          'https://healthengine.com.au/dental/why-are-regular-dental-checkups-important-and-how-do-they-protect-your-teeth',
      },
      {
        title: 'Tooth Pain',
        url:
          'https://healthengine.com.au/dental/dental-guide-on-tooth-pain-causes-symptoms-and-treatment',
      },
      {
        title: 'Scaling',
        url:
          'https://healthengine.com.au/dental/dental-scaling-and-root-planing-deep-teeth-cleaning',
      },
      {
        title: 'Cavities',
        url:
          'https://healthengine.com.au/dental/ultimate-guide-to-dental-cavities-why-you-get-them-and-the-dental-treatment',
      },
      {
        title: 'Wisdom tooth',
        url:
          'https://healthengine.com.au/dental/your-guide-to-wisdom-tooth-growth-pain-extraction-and-removal',
      },
      {
        title: 'Gum Disease',
        url: 'https://healthengine.com.au/dental/your-dental-guide-to-gum-disease-gingivitis',
      },
      {
        title: 'Fillings',
        url: 'https://healthengine.com.au/dental/the-complete-guide-to-tooth-fillings',
      },
      {
        title: 'Crowns',
        url:
          'https://healthengine.com.au/dental/dental-guide-to-tooth-crowns-costs-types-of-crowns-and-the-procedure',
      },
      {
        title: 'Missing Teeth/broken teeth/chipped tooth',
        url:
          'https://healthengine.com.au/dental/dental-guide-to-repairing-chipped-missing-and-broken-teeth',
      },
      {
        title: 'Tooth Sensitivity Treatment',
        url: 'https://healthengine.com.au/dental/teeth-sensitivity-causes-symptoms-and-treatment',
      },
      {
        title: 'Orthodontics and Invisalign',
        url:
          'https://healthengine.com.au/dental/how-orthodontics-can-fix-crooked-teeth-bite-problems-and-other-dental-issues',
      },
      {
        title: 'Dentures',
        url:
          'https://healthengine.com.au/dental/the-complete-guide-to-denture-types-costs-and-procedure',
      },
      {
        title: 'Implants',
        url:
          'https://healthengine.com.au/dental/dental-implants-complete-guide-to-procedure-costs-risks-and-more',
      },
      {
        title: 'Dental Veneers',
        url:
          'https://healthengine.com.au/dental/guide-to-veneers-how-much-they-cost-and-different-types-of-veneers',
      },
      {
        title: 'Teeth Whitening',
        url:
          'https://healthengine.com.au/dental/how-to-whiten-teeth-guide-to-teeth-whitening-treatment-costs-options',
      },
      {
        title: 'Teeth Grinding',
        url:
          'https://healthengine.com.au/dental/bruxism-teeth-grinding-symptoms-diagnosis-treatment-and-prevention',
      },
      {
        title: 'Jaw Pain',
        url:
          'https://healthengine.com.au/dental/jaw-pain-and-tmj-disorder-causes-symptoms-treatment-and-exercises',
      },
    ]);

  return (
    <>
      {capitalCitiesToShowLinks.includes(filters.location?.metro || '') &&
        (isSidebar ? (
          <SidebarLinkSection title="Dental Care Information" links={links} />
        ) : (
          <LinkSection title="Dental Care Information" links={links} />
        ))}
    </>
  );
};
